module.exports = __webpack_public_path__ + "static/media/arrow-down-left.b2258bdc.svg";